import React, { useState, useRef, useReducer, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import axios from 'axios'
import Select from 'react-select'
import { notification } from 'antd';

import SAISVG from '../../../../../../_template/helpers/CommonFunction';
import ValidationMessage from '../../../../../component/common/ValidationMessage';
import ButtonLoader from '../../../../../component/common/ButtonLoader';
let _ = require('lodash');

const initialState = {
    widget_id: "",
    widget_name: "",
    hook_url: "",
    widget_avatar: null,
    widget_icon: null,
    choose_theme: false,
    theme_color: "",
    is_voice_active: false,
    is_attachment_active: false,
    is_survey_active: false,
    survey_title: "",
    survey_description: "",
    welcome_message: "",
    widget_type: "E",
    errors: {}
};

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_FIELD":
            return { ...state, [action.field]: action.value };
        case "SET_FILE":
            return { ...state, [action.field]: action.file };
        case "REMOVE_FILE":
            return { ...state, [action.field]: null };
        case "TOGGLE_FIELD":
            return { ...state, [action.field]: !state[action.field] };
        case "SET_ERRORS":
            return { ...state, errors: action.errors };
        case "SET_FORM_DATA":
            return { ...state, ...action.payload };
        case "RESET":
            return initialState;
        default:
            return state;
    }
};

const AddChatWidgetForm = (props) => {
    const loginUserType = localStorage.getItem('type');
    const [api, contextHolder] = notification.useNotification();
    const api_base_url = process.env.REACT_APP_API_URL;
    const [state, dispatch] = useReducer(reducer, initialState);

    const [isVisible, setIsVisible] = useState(false);
    const [allowSurvey, setAllowSurvey] = useState(false);
    const [colorType, setColorType] = useState(null);

    const [widgetAvtarPreview, setWidgetAvtarPreview] = useState();
    const [widgetIconPreview, setWidgetIconPreview] = useState();
    const [theme, setTheme] = useState("#000000");

    const initialElement = [{ id: Date.now(), type: null, values: {} }];
    const [elements, setElements] = useState(initialElement);
    const [errors, setErrors] = useState({});
    const [isChangeSelecttag, setIsChangeSelecttag] = useState(false);
    const [buttonLoader , setButtonLoader] = useState(false);

    const [avaterImageChange, setAvaterImageChange] = useState(false);
    const [iconImageChange, setIconImageChange] = useState(false);
    const firstInputRef = useRef(null);
    const [searchValue, setSearchValue] = useState('');

    useEffect(()=>{
        const fetchWidgetData = async() => {
            try {
                const api_params = {};

                let apiToken = '';
                if(loginUserType === 'A'){
                    apiToken = localStorage.getItem('token')
                }
                else if(loginUserType === 'D'){
                    apiToken = localStorage.getItem('developertoken')
                }
                else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }
                const api_headers = {
                    headers: { 
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "x-access-token" : apiToken
                    }
                };
                api_params.widget_id = props.widgetId;
                api_params.sass_id = localStorage.getItem('sass_id');
    
                await axios.post(`${api_base_url}admin/get-widget-details`, api_params, api_headers)
                    .then(async (res) => {
                        if(res.data.status === 'success') {
                            setIsVisible(true);
                            if (firstInputRef.current) {
                                firstInputRef.current.focus();
                            }
                            const body = document.querySelector('#root');

                            body.scrollIntoView({
                                behavior: 'smooth'
                            }, 500)
                            const widgetData = res.data.data[0];

                            setAvaterImageChange(false);
                            setIconImageChange(false);

                            setWidgetAvtarPreview(widgetData.widget_avatar.filePath);
                            setWidgetIconPreview(widgetData.widget_icon.filePath);
                            setColorType(widgetData.color_type);
                            setTheme(widgetData.theme_color);

                            // setTimeout(() => {
                            //     if (firstInputRef.current) {
                            //         firstInputRef.current.focus();
                            //     }
                            // }, 100);
                            
                            var textPart = '';
                            if(widgetData.widget_welcome_msg) {
                                textPart = widgetData.widget_welcome_msg.split('{')[0].trim();
                                const jsonMatches = widgetData.widget_welcome_msg.match(/{.*?}/g);
                                const parsedData = jsonMatches ? jsonMatches.map((item) => JSON.parse(item)) : [];
                                
                                const transformed_data = transformKeys(parsedData);

                                if (transformed_data?.length) {
                                    const mappedData = transformed_data.map((item) => ({
                                        id: Date.now() + Math.random(),
                                        type: item.type,
                                        values: item
                                    }));
                                    setElements(mappedData);
                                }
                            }

                            const transformedData = {
                                ...widgetData,
                                is_voice_active: widgetData.allow_voice === "Y",
                                is_attachment_active: widgetData.allow_attachment === "Y",
                                is_survey_active: widgetData.allow_survey === "Y",
                                welcome_message: textPart,
                                choose_theme: widgetData.color_type,
                                theme_color: widgetData.theme_color,
                            };
                            setAllowSurvey(transformedData.is_survey_active);
                            // Optionally remove the old keys if needed
                            delete transformedData.allow_voice;
                            delete transformedData.allow_attachment;
                            delete transformedData.allow_survey;
                            
                            dispatch({ type: "SET_FORM_DATA", payload: transformedData });
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    }) 
            } catch (error) {
                console.error("Error submitting form:", error);
            }
        }
        if(props.widgetId) fetchWidgetData();
    },[props.widgetId])

    const handleSurveyCheckboxChange = (event) => {
        setAllowSurvey(event.target.checked);
        handleToggle("is_survey_active")
    };
    const handleColorRadioButtonChange = (event) => {
        setColorType(event.target.value);
        setTheme('');
        dispatch({ type: "SET_FIELD", field: "choose_theme", value: true }); // ✅ always true when choosing
        dispatch({ type: "SET_FIELD", field: "theme_color", value: '' });
    };
    const handleGradientColorRadioButtonChange = (event) => {
        const selectedValue = event.target.value;
        setTheme(selectedValue);
        dispatch({ type: "SET_FIELD", field: "theme_color", value: selectedValue }); // ✅ pass value
        dispatch({ type: "SET_ERRORS", errors: { ...state.errors, ["theme_color"]: undefined } });
    };
    const handelSolidColorChange = (event) => {
        setTheme(event.target.value)
        var solidColor = event.target.value;
        dispatch({ type: "TOGGLE_FIELD", field: "theme_color" })
        dispatch({ type: "SET_FIELD", field: "theme_color", value: solidColor });
        dispatch({ type: "SET_ERRORS", errors: { ...state.errors, ["theme_color"]: undefined } });
    }
    const widgetavtarInputRef = useRef(null);
    const widgeticonInputRef = useRef(null);
    // for widget avtar image
    const clickWidgetAvtarHandler = () => {
        if (widgetavtarInputRef.current) {
            widgetavtarInputRef.current.click();
        }
    }
    const widgetAvtarChangeHandler = (event) => {
        const { name, files } = event.target;
        const widgetAvterFile = files[0];
        
        if(widgetAvterFile){
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    if (img.naturalWidth === 160 && img.naturalHeight === 160) {
                        setWidgetAvtarPreview(URL.createObjectURL(widgetAvterFile));
                        dispatch({ type: "SET_FILE", field: name, file: files[0] });
                        dispatch({ type: "SET_ERRORS", errors: { ...state.errors, [name]: undefined } });
                        setAvaterImageChange(true);
                    } else {
                        toast.error(`Invalid image dimensions: ${img.naturalWidth}x${img.naturalHeight}. Please upload an image of size 160x160.`);
                    }
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(widgetAvterFile);
        }
    }
    const widgetAvtarPreviewRemoveHandler = () => {
        dispatch({ type: "REMOVE_FILE", field: "widget_avatar" });
        setWidgetAvtarPreview('');
        setAvaterImageChange(false);
    }
    // for widget icon
    const clickWidgetIconHandler = () => {
        if (widgeticonInputRef.current) {
            widgeticonInputRef.current.click();
        }
    }
    const widgetIconChangeHandler = (event) => {
        const { name, files } = event.target;
        const widgetIconFile = files[0];
        
        dispatch({ type: "SET_FILE", field: name, file: files[0] });
        dispatch({ type: "SET_ERRORS", errors: { ...state.errors, [name]: undefined } });

        if(widgetIconFile){
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    if (img.naturalWidth === 200 && img.naturalHeight === 200) {
                        setWidgetIconPreview(URL.createObjectURL(widgetIconFile));
                        setIconImageChange(true);
                    } else {
                        toast.error(`Invalid image dimensions: ${img.naturalWidth}x${img.naturalHeight}. Please upload an image of size 200x200.`);
                    }
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(widgetIconFile);
        }
    }
    const widgetIconPreviewRemoveHandler = () => {
        dispatch({ type: "REMOVE_FILE", field: "widget_icon" });
        setWidgetIconPreview('');
        setIconImageChange(false);
    }
    ////////////////////////////////////////////
    //////////////////////////////////////////
    const validate = () => {
        let errors = {};
        if (state.widget_type === "E" && !state.widget_name) errors.widget_name = "Widget name is required";
        if (state.widget_type === "E" && !state.hook_url) errors.hook_url = "Hook URL is required";

        if (state.is_survey_active) {
            if (!state.survey_title) errors.survey_title = "Survey title is required";
            if (!state.survey_description) errors.survey_description = "Survey description is required";
        }

        if (state.choose_theme && !state.theme_color) {
            errors.theme_color = "Theme color is required when choosing a theme";
        }
    
        dispatch({ type: "SET_ERRORS", errors });
        return Object.keys(errors).length === 0;
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        dispatch({ type: "SET_FIELD", field: name, value });

        // Remove error when user starts typing
        dispatch({ type: "SET_ERRORS", errors: { ...state.errors, [name]: undefined } });
    };
    
    const handleToggle = (field) => {
        dispatch({ type: "TOGGLE_FIELD", field });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!validate()) return;
        if(isChangeSelecttag) {
            if(!validateWelcomMessage()) return;
        }
        setButtonLoader(true);
        var message = state.welcome_message+" ";
        var all_kind_message = '';
        for(let i=0; i<elements.length; i++) {
            if(elements[i].type == "button") {
                // var uri_value = `/Inquriy{\"${elements[i].values.buttonValue}\": \"${elements[i].values.buttonValue}\"}`;
                // let encoded = encodeURIComponent(uri_value);
                all_kind_message += '{"type":"button","label":"' + elements[i].values.buttonLabel + '","bg_color":"' + elements[i].values.buttonColor + '","text_color":"' + elements[i].values.buttonTextColor + '","value":"'+elements[i].values.buttonType+'","data1":"'+elements[i].values.uniqueValue+'","data2":"'+elements[i].values.buttonValue+'"}';
            } else if(elements[i].type == "text_box") {
                //var text_msg = 
            } else if(elements[i].type == "link") {
                all_kind_message += '{"type": "link","name":"'+elements[i].values.link+'","url":"'+elements[i].values.link+'"}';
            } else if(elements[i].type == "image") {
                all_kind_message += '{"type": "image","file_data":"'+elements[i].values.image+'"}';
            } else if(elements[i].type == "video") {
                all_kind_message += '{"type": "video","url":"'+elements[i].values.video+'"}';
            } else if (elements[i].type == "audio") {
                all_kind_message += '{"type": "audio","url":"'+elements[i].values.audio+'"}';
            }
        }
        message += all_kind_message;
        try {
            if(!theme){
                api["error"]({
                    message: 'Error',
                    description: 'Please! Select a Widget Theme Color'
                });
                return;
            }
            const formData = new FormData();
            if (props.widgetId) formData.append("widget_id", props.widgetId);
            formData.append("widget_type", state.widget_type);
            formData.append("widget_name", state.widget_name);
            formData.append("hook_url", state.hook_url);
            if (state.widget_avatar && avaterImageChange) formData.append("widget_avatar", state.widget_avatar);
            if (state.widget_icon && iconImageChange) formData.append("widget_icon", state.widget_icon);
            if (state.theme_color) formData.append("theme_color", theme);
            formData.append("color_type", colorType);
            formData.append("is_voice_active", state.is_voice_active ? "Y" : "N");
            formData.append("is_attachment_active", state.is_attachment_active ? "Y" : "N");
            formData.append("is_survey_active", state.is_survey_active ? "Y" : "N");
            if (state.is_survey_active) {
              formData.append("survey_title", state.survey_title);
              formData.append("survey_description", state.survey_description);
            }
            formData.append("welcome_message", message);
            formData.append("sass_id", localStorage.getItem('sass_id'));
            formData.append("type", loginUserType);
            formData.append("login_user_name", loginUserType == 'SA' ? localStorage.getItem('system_username') : '');

            let apiToken = '';
            if(loginUserType === 'A'){
                apiToken = localStorage.getItem('token')
            }
            else if(loginUserType === 'D'){
                apiToken = localStorage.getItem('developertoken')
            }
            else if(loginUserType === 'SA') {
                apiToken = localStorage.getItem('systemAdminToken')
            }

            const api_headers = {
                headers: { 
                    "Content-Type": "multipart/form-data",
                    "x-access-token" : apiToken
                }
            };

            await axios.post(`${api_base_url}admin/add-chat-widget`, formData, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        setButtonLoader(false);
                        var message = '';
                        if(props.widgetId) {
                            message = `Widget successfully updated`;
                        } else {
                            message = `Widget successfully saved`;
                        }
                        api["success"]({
                            message: 'Success',
                            description: message
                        });
                        dispatch({ type: "RESET" });
                        widgetAvtarPreviewRemoveHandler();
                        widgetIconPreviewRemoveHandler();
                        setElements(initialElement);
                        setErrors({});
                        setIsVisible(false);
                        setAvaterImageChange(false);
                        setIconImageChange(false);
                        props.recordInserted(res.data.data);
                        if(props.widgetId) props.recordUpdated(props.widgetId, res.data.data[0]);
                    } else if(res.data.status === 'error') {
                        toast.error(res.data.message);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setButtonLoader(false);
                }) 
        } catch (error) {
            console.error("Error submitting form:", error);
            setButtonLoader(false);
        } finally {
            //setIsSubmitting(false);
            setButtonLoader(false);
        }
    }

    const messageTypeOptions = [
        { value: "button", label: "Button" },
        // { value: "text_box", label: "Text Box" },
        { value: "link", label: "Link" },
        { value: "image", label: "Image" },
        { value: "video", label: "Video" },
        { value: "audio", label: "Audio" },
    ];

    const msgType = [
        { value: "Info", label: "Info" },
        { value: "Inquiry", label: "Inquiry" },
        { value: "Service", label: "Service" }
    ];
    // Add a new select input
    const elementAddHandler = () => {
        setElements([
            ...elements,
            { id: Date.now(), type: null, values: {} }, // Each element gets a unique ID
        ]);
    };
    // Remove a select input
    const elementRemoveHandler = (id) => {
        setElements(elements.filter((el) => el.id !== id));
        setErrors((prev) => {
            const updatedErrors = { ...prev };
            delete updatedErrors[id];
            return updatedErrors;
        });
    };
    // Validate fields when selecting an option
    const validateOnSelect = (id, selectedOption) => {
        const newErrors = { ...errors };
    
        if (!selectedOption) {
            newErrors[id] = { type: "Please select a message type." };
        } else {
            newErrors[id] = {};
        }

        setErrors(newErrors);
    };
    // Update selected type for each select field
    const handleSelectChange = (id, selectedOption) => {
        setElements(
            elements.map((el) =>
                el.id === id ? { ...el, type: selectedOption?.value || null, values: {} } : el
            )
        );
        //setErrors((prev) => ({ ...prev, [id]: {} }));
        validateOnSelect(id, selectedOption);
        setIsChangeSelecttag(true);
    };
    // Handle input changes
    const handleInputChange = (id, field, value) => {
        setElements(
            elements.map((el) =>
                el.id === id ? { ...el, values: { ...el.values, [field]: value } } : el
            )
        );

        setErrors((prev) => ({
            ...prev,
            [id]: { ...prev[id], [field]: value ? "" : `This field is required.` }, // Clear error when user types
        }));
    };
    // Validate form
    const validateWelcomMessage = () => {
        let isValid = true;
        const newErrors = {};
        elements.forEach((el) => {
            if (!el.type) {
                newErrors[el.id] = { type: "Please select a message type." };
                isValid = false;
            } else {
                newErrors[el.id] = {};
                if (el.type === "button") {
                    if (!el.values.buttonType) {
                        newErrors[el.id].buttonType = "Button type is required.";
                        isValid = false;
                    }
                    if (!el.values.buttonLabel) {
                        newErrors[el.id].buttonLabel = "Button label is required.";
                        isValid = false;
                    }
                    if (!el.values.buttonValue) {
                        newErrors[el.id].buttonValue = "Button value is required.";
                        isValid = false;
                    }
                    if (!el.values.uniqueValue) {
                        newErrors[el.id].uniqueValue = "Button unique id is required.";
                        isValid = false;
                    }
                    if (!el.values.buttonColor) {
                        newErrors[el.id].buttonColor = "Button color is required.";
                        isValid = false;
                    }
                    if (!el.values.buttonTextColor) {
                        newErrors[el.id].buttonTextColor = "Button text color is required.";
                        isValid = false;
                    }
                }
                if (el.type === "text_box") {
                    if (!el.values.textBoxLabel) {
                        newErrors[el.id].textBoxLabel = "Text box label is required.";
                        isValid = false;
                    }
                    if (!el.values.textBoxValue) {
                        newErrors[el.id].textBoxValue = "Text box value is required.";
                        isValid = false;
                    }
                }
                if (el.type === "link") {
                    if (!el.values.link) {
                        newErrors[el.id].link = "Link is required.";
                        isValid = false;
                    }
                }
                if (el.type === "image") {
                    if (!el.values.image) {
                        newErrors[el.id].image = "Image url is required.";
                        isValid = false;
                    }
                }
                if (el.type === "video") {
                    if (!el.values.video) {
                        newErrors[el.id].video = "Video url is required.";
                        isValid = false;
                    }
                }
                if (el.type === "audio") {
                    if (!el.values.audio) {
                        newErrors[el.id].audio = "Audio is required.";
                        isValid = false;
                    }
                }
            }
        });

        setErrors(newErrors);
        return isValid;
    };
    //////////////////////////////
    const keyMapping = {
        bg_color: "buttonColor",
        data1: "uniqueValue",
        data2: "buttonValue",
        label: "buttonLabel",
        text_color: "buttonTextColor",
        value: "buttonType",
        name: "link",
        url: "",
        file_data: "image"
    };

    const transformKeys = (data) => {
        return data.map((item) => {
            const transformedItem = {};
    
            for (const key in item) {
                if (key === 'url') {
                    if (item.type === 'link') {
                        transformedItem['link'] = item.url;
                    } else if (item.type === 'video') {
                        transformedItem['video'] = item.url;
                    } else if (item.type === 'audio') {
                        transformedItem['audio'] = item.url;
                    }
                } else {
                    transformedItem[keyMapping[key] || key] = item[key];
                }
            }
            return transformedItem;
        });
    };

    var formData = {
        widget_name: ''
    };

    const handleSearchSubmit = () => {
        if(searchValue.trim().length > 0) {
            formData.widget_name = searchValue.trim();
            props.searchWidget(formData);
        }
    }

    const formCloseHandler = (e) => {
        setIsVisible(false);
        dispatch({ type: "RESET" });
        widgetAvtarPreviewRemoveHandler();
        widgetIconPreviewRemoveHandler();
        setElements(initialElement);
        setErrors({});
        setIsVisible(false);
        setAvaterImageChange(false);
        setIconImageChange(false);
        setColorType(null);
        setTheme('#000000');
    }

    return (
        <>
        {!isVisible && <div className="row">
            <div className="col-md-12">
                <div className="card card-flush border" id="user_add_card">
                    <div className="card-header py-3">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-gray-800 fs-2">Chat Widget</span>
                            <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                Total {props.totalRecords} chat widget are available
                            </span>
                        </h3>
                        <div className="card-toolbar">
                            <div className="d-flex flex-stack flex-wrap gap-4">
                                <div className="position-relative my-1 m-w-100">
                                    {/* <input
                                        type="text" 
                                        className="form-control search-user w-350px" placeholder="Search"
                                        name='widget_name'
                                        onChange={(evt)=>setSearchValue(evt.target.value)}
                                    /> */}
                                    <div className="input-group">
                                        <input 
                                            type="text" 
                                            className="form-control w-350px" 
                                            placeholder="Search"
                                            name='widget_name'
                                            onChange={(evt)=>setSearchValue(evt.target.value)}
                                        />
                                        <span 
                                            className="input-group-text cursor-pointer"
                                            onClick={handleSearchSubmit}
                                            disabled={props.loader_status ? true : false}
                                        >
                                            {
                                                !props.loader_status &&
                                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                                            }
                                            {
                                                props.loader_status &&
                                                <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                                            }
                                            
                                        </span>
                                    </div>
                                </div>
                                {/* {!props.loader_status && <button type="submit" className="btn btn-dark btn-icon btn-sm p-6" onClick={handleSearchSubmit}>
                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                </button> } */}
                                {/* {props.loader_status && <button type="button" className="btn btn-dark btn-icon btn-sm p-6" >
                                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                                </button> } */}
                                <div className="d-flex align-items-center fw-bold" onClick={()=>setIsVisible(true)}>
                                    <a className="btn btn-primary px-6 add-new-user">
                                        Add Chat Widget
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>}

        {isVisible && <div className='row'>
            <div className='col-md-12'>
                <div className="card card-flush border" id="user_add_card">
                    <div className="card-header py-3">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-gray-800 fs-2">
                                Configure Chat Widget
                            </span>
                        </h3>
                    </div>
                    <div className={`card-body pt-0`}>
                        <form onSubmit={handleSubmit}>
                            <input type='hidden' name="hidden_widget_id" value={props.widgetId} />
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="mb-5">
                                        <label className="form-label required">
                                            Widget Name
                                        </label>
                                        <input
                                            type="text"
                                            name="widget_name"
                                            className={`form-control form-control-solid`}
                                            placeholder="Enter widget name"
                                            value={state.widget_name}
                                            disabled={state.widget_type == "I"}
                                            onChange={handleChange}
                                            ref={firstInputRef}
                                        />
                                        {state.errors.widget_name && <ValidationMessage className='text-danger' message={state.errors.widget_name}/>}
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="mb-5">
                                        <label className="form-label">
                                            Allow Voice
                                        </label>
                                        <div className="form-check form-switch form-check-custom form-check-solid me-10 mt-2">
                                            <input className="form-check-input" value={state.is_voice_active} checked={state.is_voice_active} type="checkbox" onChange={() => handleToggle("is_voice_active")} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="mb-5">
                                        <label className="form-label">
                                            Allow Attachment
                                        </label>
                                        <div className="form-check form-switch form-check-custom form-check-solid me-10 mt-2">
                                            <input className="form-check-input" value={state.is_attachment_active} checked={state.is_attachment_active} type="checkbox" onChange={() => handleToggle("is_attachment_active")} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="mb-5">
                                        <label className="form-label">
                                            Allow Survey
                                        </label>
                                        <div className="form-check form-switch form-check-custom form-check-solid me-10 mt-2">
                                            <input className="form-check-input" checked={state.is_survey_active} type="checkbox" value={allowSurvey} onChange={handleSurveyCheckboxChange}/>
                                        </div>
                                    </div>
                                </div>
                                {allowSurvey && <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-5">
                                            <label className="form-label required">
                                                Survey Title
                                            </label>
                                            <input
                                                type="text"
                                                name="survey_title"
                                                className="form-control form-control-solid"
                                                placeholder="Enter widget name"
                                                value={state.survey_title || ''} 
                                                onChange={handleChange}
                                            />
                                            {state.errors.survey_title && <ValidationMessage className='text-danger' message={state.errors.survey_title}/>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-5">
                                            <label className="form-label required">
                                                Survey Description
                                            </label>
                                            <textarea 
                                                name="survey_description"
                                                className="form-control form-control-solid" 
                                                rows="1"
                                                value={state.survey_description || ''} 
                                                onChange={handleChange}
                                            ></textarea>
                                            {state.errors.survey_description && <ValidationMessage className='text-danger' message={state.errors.survey_description}/>}
                                        </div>
                                    </div>
                                </div>}
                                <div className='col-md-8'></div>
                               {state.widget_type === "E" && <div className="col-md-6">
                                    <div className="mb-5">
                                        <label className="form-label required">
                                            Hook URL
                                        </label>
                                        <textarea 
                                            className="form-control form-control-solid" 
                                            rows="5"
                                            name="hook_url"
                                            value={state.hook_url}
                                            onChange={handleChange}
                                        ></textarea>
                                        {state.errors.hook_url && <ValidationMessage className='text-danger' message={state.errors.hook_url}/>}
                                    </div>
                                </div>}
                                <div className={state.widget_type === "I" ? `col-md-6 mw-5` : `col-md-3 mw-5`}>
                                    <label className="form-label required">
                                        Avatar
                                    </label>
                                    <div className="card-body border border-dashed border-gray-300 d-flex text-center flex-column bg-light p-5 align-items-center position-relative">
                                        {!widgetAvtarPreview ?
                                            <a
                                                className="text-gray-800 d-flex flex-column cursor-pointer"
                                                onClick={(e) => { e.preventDefault(); clickWidgetAvtarHandler() }} 
                                            >
                                                <div className="symbol symbol-60px mb-2">
                                                    <SAISVG path="media/icons/duotune/general/gen035.svg" className="svg-icon-muted svg-icon-3hx" />
                                                </div>
                                                <div className="fw-semibold fs-5">
                                                    Widget Avatar
                                                </div>
                                                <div className="text-primary">
                                                    (160 X 160 image are accepted)
                                                </div> 
                                            </a> 
                                        : 
                                            <>
                                                <FontAwesomeIcon
                                                    icon={faXmark} 
                                                    style={{marginLeft:'100%', position:'absolute', top:'5', right:'5'}} 
                                                    className='fs-3 text-gray-600 cursor-pointer' 
                                                    onClick={widgetAvtarPreviewRemoveHandler}
                                                />
                                                <img
                                                    src={widgetAvtarPreview}
                                                    alt="Selected"
                                                    className="w-100"
                                                    style={{ height: "95px", objectFit: "contain" }}
                                                /> 
                                            </>}
                                        <input 
                                            name="widget_avatar"
                                            type='file' 
                                            className='d-none'
                                            ref={widgetavtarInputRef}
                                            onChange={widgetAvtarChangeHandler}
                                        />           
                                    </div>
                                    {state.errors.widget_avatar && <ValidationMessage className='text-danger' message={state.errors.widget_avatar}/>}
                                </div>
                                <div className={state.widget_type === "I"?`col-md-6 mb-5`:`col-md-3 mb-5`}>
                                    <label className="form-label">
                                        &nbsp;
                                    </label>
                                    <div className="card-body border border-dashed border-gray-300 d-flex text-center flex-column bg-light p-5 align-items-center position-relative">
                                        {!widgetIconPreview ? 
                                            <a 
                                                href="#" 
                                                className="text-gray-800 d-flex flex-column cursor-pointer"
                                                onClick={(e) => { e.preventDefault(); clickWidgetIconHandler() }} 
                                            >
                                                <div className="symbol symbol-60px mb-2">
                                                    <SAISVG path="media/icons/duotune/general/gen035.svg" className="svg-icon-muted svg-icon-3hx" />
                                                </div>
                                                <div className="fw-semibold fs-5">
                                                    Widget Icon
                                                </div>
                                                <div className="text-primary">
                                                    (200 X 200 image are accepted)
                                                </div> 
                                            </a>
                                        :
                                            <>
                                            <FontAwesomeIcon
                                                icon={faXmark} 
                                                style={{marginLeft:'100%', position:'absolute', top:'5', right:'5'}} 
                                                className='fs-3 text-gray-600 cursor-pointer' 
                                                onClick={widgetIconPreviewRemoveHandler}
                                            />
                                            <img
                                                src={widgetIconPreview}
                                                alt="Selected"
                                                className="w-100"
                                                style={{ height: "95px", objectFit: "contain" }}
                                            /> 
                                            </>}
                                        <input
                                            type='file'
                                            name='widget_icon'
                                            className='d-none'
                                            ref={widgeticonInputRef}
                                            onChange={widgetIconChangeHandler}
                                        />      
                                    </div>
                                    {state.errors.widget_icon && <ValidationMessage className='text-danger' message={state.errors.widget_icon}/>}
                                </div>
                                <div className='col-md-3'>
                                    <div className='mb-5'>
                                        <label className="form-label">
                                            Choose Widget Theme
                                        </label>
                                        <div className="mb-10 d-flex jc-sb">
                                            <div className="form-check form-check-custom form-check-solid">
                                                <input name="choose_theme" className="form-check-input" type="radio" value="g_color" checked={colorType === "g_color"} onChange={handleColorRadioButtonChange} />
                                                <label className="form-check-label">
                                                    Gradient Color
                                                </label>
                                            </div>

                                            <div className="form-check form-check-custom form-check-solid">
                                                <input name="choose_theme" className="form-check-input" type="radio" value="l_color" checked={colorType === "l_color"} onChange={handleColorRadioButtonChange} />
                                                <label className="form-check-label">
                                                    Solid Color
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {colorType === 'g_color' && <div className="col-md-4">
                                    <div className='col-md-12'>
                                        <div className="mb-5">
                                            <label className="form-label required">
                                                Widget Theme
                                            </label>
                                            <div className="mb-1 d-flex">
                                                <div className="form-check form-check-custom form-check-solid me-10">
                                                    <input className='form-check-input h-40px w-40px bubble_1 gr-theme' type="radio" value="linear-gradient(to right, #010101, #230444, #413f42, #7b787c, #aaa8ab)" onChange={handleGradientColorRadioButtonChange} checked={theme === "linear-gradient(to right, #010101, #230444, #413f42, #7b787c, #aaa8ab)"} />
                                                </div>

                                                <div className="form-check form-check-custom form-check-solid me-10">
                                                    <input className='form-check-input h-40px w-40px bubble_2 gr-theme' type="radio" value="linear-gradient(to right, #3e0448, #6a047b, #a003bb, #be0fdc, #d439ee)" onChange={handleGradientColorRadioButtonChange} checked={theme === "linear-gradient(to right, #3e0448, #6a047b, #a003bb, #be0fdc, #d439ee)"} />
                                                </div>

                                                <div className="form-check form-check-custom form-check-solid me-10">
                                                    <input className='form-check-input h-40px w-40px bubble_3 gr-theme' type="radio" value="linear-gradient(to right, #076189, #0680b6, #069cde, #3dc1fb, #4fc7fb)" onChange={handleGradientColorRadioButtonChange} checked={theme === "linear-gradient(to right, #076189, #0680b6, #069cde, #3dc1fb, #4fc7fb)"} />
                                                </div>

                                                <div className="form-check form-check-custom form-check-solid me-10">
                                                    <input className='form-check-input h-40px w-40px bubble_4 gr-theme' type="radio" value="linear-gradient(to right, #891515, #bd1b1b, #d72525, #ef3232, #ff2222)" onChange={handleGradientColorRadioButtonChange} checked={theme === "linear-gradient(to right, #891515, #bd1b1b, #d72525, #ef3232, #ff2222)"} />
                                                </div>

                                                <div className="form-check form-check-custom form-check-solid me-10">
                                                    <input className='form-check-input h-40px w-40px bubble_5 gr-theme' type="radio" value="linear-gradient(to right, #185c05, #1e7805, #27a504, #37d80a, #67e544)" onChange={handleGradientColorRadioButtonChange} checked={theme === "linear-gradient(to right, #185c05, #1e7805, #27a504, #37d80a, #67e544)"} />
                                                </div>

                                                <div className="form-check form-check-custom form-check-solid me-10">
                                                    <input className='form-check-input h-40px w-40px bubble_6 gr-theme' type="radio" value="linear-gradient(to right, #030355, #040470, #040495, #0606b9, #0d0de7)" onChange={handleGradientColorRadioButtonChange} checked={theme === "linear-gradient(to right, #030355, #040470, #040495, #0606b9, #0d0de7)"} />
                                                </div>
                                            </div>
                                            {(state.errors.theme_color || theme == '') && <ValidationMessage className='text-danger' message={state.errors.theme_color}/>}
                                        </div>
                                    </div>
                                </div>}
                                {colorType === 'l_color' && <div className='col-md-4'>
                                    <div className="mb-5">
                                        <label className="form-label required">
                                            Widget Theme
                                        </label>
                                        <input type="color" className="form-control form-control-solid" name="button_color" value={theme} style={{height:'42px'}} onChange={handelSolidColorChange} />
                                        {(state.errors.theme_color || theme == '') && <ValidationMessage className='text-danger' message={state.errors.theme_color}/>}
                                    </div>
                                </div>}
                                <div className="col-md-12">
                                    <div className="mb-5">
                                        <label className="form-label">
                                            Welcome Message
                                        </label>
                                        <textarea 
                                            className="form-control form-control-solid" 
                                            rows="5" name="welcome_message" value={state.welcome_message} onChange={handleChange}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="separator separator-dashed border-gray-400 my-5"></div>
                                <div className='row'>
                                    <div className="d-flex flex-column">
                                        <h4 className="fw-bold text-dark">
                                            Add Element In welcome Message
                                        </h4>
                                    </div>
                                    {elements.map((el, index) => (
                                        <div className="row mb-3" key={el.id}>
                                            <div className="col-md-3">
                                                <Select
                                                    className="react-select-styled react-select-solid"
                                                    classNamePrefix="react-select"
                                                    options={messageTypeOptions}
                                                    value={messageTypeOptions.find((opt) => opt.value === el.type)}
                                                    onChange={(selectedOption) => handleSelectChange(el.id, selectedOption)}
                                                    placeholder="Select an option"
                                                    isClearable
                                                />
                                                {errors[el.id]?.type && <ValidationMessage className='text-danger' message={errors[el.id].type} />}
                                            </div>
                                            <div className="col-md-8">
                                                {el.type === "button" && (
                                                    <div className='row'>
                                                        <div className="col-md-4 mb-5">
                                                            <Select
                                                                className="react-select-styled react-select-solid"
                                                                classNamePrefix="react-select"
                                                                options={msgType}
                                                                name="button_type"
                                                                value={msgType.find((opt) => opt.value === el.values.buttonType )}
                                                                onChange={(selectedOption) => handleInputChange(el.id, "buttonType", selectedOption.value)}
                                                                placeholder="Select button type"
                                                                isClearable
                                                            />
                                                            {errors[el.id]?.buttonType && <ValidationMessage className='text-danger' message={errors[el.id].buttonType} />}
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-solid"
                                                                name="button_lable"
                                                                placeholder="Enter button lable"
                                                                value={el.values.buttonLabel}
                                                                onChange={(e) => handleInputChange(el.id, "buttonLabel", e.target.value)}
                                                            />
                                                            {errors[el.id]?.buttonLabel &&<ValidationMessage className='text-danger' message={errors[el.id].buttonLabel}/>}
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-solid"
                                                                placeholder="Enter value"
                                                                name="value"
                                                                value={el.values.buttonValue}
                                                                onChange={(e) => handleInputChange(el.id, "buttonValue", e.target.value)}
                                                            />
                                                            {errors[el.id]?.buttonValue && <ValidationMessage className='text-danger' message={errors[el.id].buttonValue}/>}
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-solid"
                                                                placeholder="Enter unique id"
                                                                name="unique_id"
                                                                value={el.values.uniqueValue}
                                                                onChange={(e) => handleInputChange(el.id, "uniqueValue", e.target.value)}
                                                            />
                                                            {errors[el.id]?.uniqueValue && <ValidationMessage className='text-danger' message={errors[el.id].uniqueValue}/>}
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <div className="input-group">
                                                                <span className="input-group-text">Button</span>
                                                                <input type="color" className="form-control form-control-solid" style={{height:'42px'}} name="button_color" value={el.values.buttonColor?el.values.buttonColor:"#000000"} onChange={(e) => handleInputChange(el.id, "buttonColor", e.target.value)}/>
                                                                {errors[el.id]?.buttonColor && <ValidationMessage className='text-danger' message={errors[el.id].buttonColor} />}
                                                            </div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <div className="input-group">
                                                                <span className="input-group-text">Text</span>
                                                                <input type="color" className="form-control form-control-solid" style={{height:'42px'}} name="text_color" value={el.values.buttonTextColor?el.values.buttonTextColor:"#ffffff"} onChange={(e) => handleInputChange(el.id, "buttonTextColor", e.target.value)} />
                                                                {errors[el.id]?.buttonTextColor && <ValidationMessage className='text-danger' message={errors[el.id].buttonTextColor} />}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {el.type === "text_box" && (
                                                    <div className='row'>
                                                        <div className='col-md-6'>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-solid"
                                                                placeholder="Enter textbox label"
                                                                onChange={(e) => handleInputChange(el.id, "textBoxLabel", e.target.value)}
                                                            />
                                                            {errors[el.id]?.textBoxLabel && <ValidationMessage className='text-danger' message={errors[el.id].textBoxLabel} /> }
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-solid"
                                                                placeholder="Enter textbox value"
                                                                onChange={(e) => handleInputChange(el.id, "textBoxValue", e.target.value)}
                                                            />
                                                            {errors[el.id]?.textBoxValue && <ValidationMessage className='text-danger' message={errors[el.id].textBoxValue} />}
                                                        </div>
                                                    </div>
                                                )}

                                                {el.type === "link" && (
                                                    <div className='row'>
                                                        <div className='col-md-12'>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-solid"
                                                                placeholder="Enter link"
                                                                value={el.values.link || ""}
                                                                onChange={(e) => handleInputChange(el.id, "link", e.target.value)}
                                                            />
                                                            {errors[el.id]?.link && <ValidationMessage className='text-danger' message={errors[el.id].link} />}
                                                        </div>
                                                    </div>
                                                )}

                                                {el.type === "image" && (
                                                    <div className='row'>
                                                        <div className='col-md-12'>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-solid"
                                                                placeholder="Enter image url"
                                                                value={el.values.image || ""}
                                                                onChange={(e) => handleInputChange(el.id, "image", e.target.value)}
                                                            />
                                                            {errors[el.id]?.image && <ValidationMessage className='text-danger' message={errors[el.id].image} />}
                                                        </div>
                                                    </div>
                                                )}

                                                {el.type === "video" && (
                                                    <div className='row'>
                                                        <div className='col-md-12'>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-solid"
                                                                placeholder="Enter video url"
                                                                value={el.values.video || ""}
                                                                onChange={(e) => handleInputChange(el.id, "video", e.target.value)}
                                                            />
                                                            {errors[el.id]?.video && <ValidationMessage className='text-danger' message={errors[el.id].video} />}
                                                        </div>
                                                    </div>
                                                )}

                                                {el.type === "audio" && (
                                                    <div className='row'>
                                                        <div className='col-md-12'>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-solid"
                                                                placeholder="Enter audio url"
                                                                value={el.values.audio || ""}
                                                                onChange={(e) => handleInputChange(el.id, "audio", e.target.value)}
                                                            />
                                                            {errors[el.id]?.audio && <ValidationMessage className='text-danger' message={errors[el.id].audio} />}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className='col-md-1 m-auto d-flex'>
                                                { elements.length != 1 &&
                                                    <div className='cursor-pointer' onClick={() => elementRemoveHandler(el.id)} >
                                                        <SAISVG 
                                                            path="media/icons/duotune/general/gen034.svg" 
                                                            className="svg-icon-danger svg-icon-2hx" 
                                                        />
                                                    </div>
                                                }
                                                { elements.length == index + 1 &&
                                                    <div className='cursor-pointer' onClick={elementAddHandler}>
                                                        <SAISVG 
                                                            path="media/icons/duotune/general/gen035.svg" 
                                                            className="svg-icon-primary svg-icon-2hx" 
                                                        />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-md-12 text-end mt-5">
                                <a 
                                    href="#" 
                                    className="btn btn-light me-4" 
                                    onClick={(e) => { e.preventDefault(); formCloseHandler()}}
                                >
                                    Close
                                </a>
                                {!buttonLoader ? <button 
                                    className={`btn btn-dark`} 
                                    type="submit"
                                >Save</button>
                                :
                                <a
                                    href="#" 
                                    className="btn btn-primary disabled"
                                    onClick={(e) => { e.preventDefault();}}
                                >
                                    <ButtonLoader btnHtml='Please wait...' className='me-2'/>
                                </a>}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>}
        {contextHolder}
        </>
    )
}

export default AddChatWidgetForm;